var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-area"},[_c('svg-placeholder',{staticClass:"drag-area__svg"}),_c('main-content',{staticClass:"drag-area__content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }